import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-page"
  }, [_c('m-head'), _c('div', {
    staticClass: "index-main"
  }, [_vm._m(0), _c('div', {
    staticClass: "index-pass"
  }, [_c('m-pass', {
    attrs: {
      "label": _vm.userInfo.uid
    }
  })], 1), _c('div', {
    staticClass: "index-hic"
  }, [_c('div', {
    staticClass: "index-hic-main"
  }, [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userInfo.coin)
    }
  })], 1)]), _c('div', {
    staticClass: "index-face",
    class: _vm.isMobile && 'wap'
  }, [_c('span', [_c('m-btn-index', {
    attrs: {
      "text": "BOTCODE",
      "fontSize": "32",
      "src": require('@images/lucky-icon-botcode.jpg')
    },
    on: {
      "skip": () => _vm.$router.push('/botcode')
    }
  }), _vm._m(1)], 1), _c('span', [_c('m-btn-index', {
    attrs: {
      "text": "SLOT",
      "src": require('@images/lucky-icon-mathine.jpg')
    },
    on: {
      "skip": () => _vm.$router.push('/slotMachine')
    }
  })], 1), _c('span', [_c('m-btn-index', {
    attrs: {
      "text": "GIFTS",
      "src": require('@images/lucky-icon-gift.jpg')
    },
    on: {
      "skip": () => _vm.$router.push('/gifts')
    }
  }), _vm._m(2)], 1), _c('span', [_c('m-btn-index', {
    attrs: {
      "text": "LUCKY",
      "src": require('@images/lucky-icon-lucky.jpg')
    },
    on: {
      "skip": () => _vm.$router.push('/turn')
    }
  })], 1), _c('span', [_c('m-btn-index', {
    attrs: {
      "noStyle": true,
      "src": require('@images/icon-rank.png')
    },
    on: {
      "skip": () => _vm.$router.push('/rank')
    }
  })], 1), _c('span', [_c('m-btn-index', {
    attrs: {
      "noStyle": true,
      "src": require('@images/icon-upgrade.png')
    },
    on: {
      "skip": () => _vm.$router.push('/upgrade')
    }
  })], 1)]), _c('div', {
    staticClass: "index-info"
  }, [_c('div', {
    staticClass: "index-btn-upgrade",
    on: {
      "click": _vm.onQuickUpgrade
    }
  }, [_c('div', {
    staticClass: "index-btn-upgrade-main"
  }, [!_vm.gameData.isQuickUpgradeLoading ? [_vm._v(" UPGRADE")] : [_vm._v(" UPGRADING "), _vm._m(3)]], 2)]), _c('div', {
    staticClass: "btn-minibot"
  }, [_c('div', {
    staticClass: "btn-minibot-item"
  }, [_c('div', {
    staticClass: "btn-minibot-tag"
  }, [_c('span', [_vm._v(_vm._s(_vm.fmt_pre(_vm.storageInfo.stock.percent)) + "%")])]), _c('m-btn-index', {
    attrs: {
      "text": "MINTBOT",
      "fontSize": _vm.devicePixelRatio > 1.5 ? 34 : 28,
      "borderRadius": "#abb4c8",
      "arcBackground": "#4c69fe",
      "src": require('@images/lucky-icon-minibot.jpg')
    },
    on: {
      "skip": () => _vm.$router.push('/bot')
    }
  })], 1)]), _c('div', {
    staticClass: "index-level wow fadeInUpBig",
    attrs: {
      "data-wow-duration": "0.5s"
    },
    on: {
      "click": _vm.upgradePageLink
    }
  }, [_c('m-level-progress', {
    attrs: {
      "progress": _vm.gameProgress.progressInfo.completion_rate * 100,
      "level": [_vm.gameProgress.currentLevel, _vm.gameProgress.nextLevel]
    }
  })], 1), _c('div', {
    staticClass: "index-bot wow bounce",
    class: _vm.isMobile && 'wap',
    attrs: {
      "data-wow-duration": "0.8s"
    },
    on: {
      "click": _vm.upgradePageLink
    }
  }, [_c('img', {
    attrs: {
      "src": require(`@images/avatar/body/${_vm.gameProgress.currentLevel >= _vm.botImgLimit ? _vm.botImgLimit : _vm.gameProgress.currentLevel}.png`),
      "alt": ""
    }
  })])])]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "pop-quickUpgrade",
      "show": _vm.upgradeResultInfo.show,
      "content": "html",
      "title": "",
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        return _vm.$set(_vm.upgradeResultInfo, "show", $event);
      },
      "close": _vm.onUpgradeResultInfoClose
    }
  }, [_c('div', {
    staticClass: "pop-quickUpgrade__title wow fadeInUp",
    attrs: {
      "data-wow-duration": "0.5s"
    }
  }, [_vm.gameData.isQuickUpgradeLoading ? [_c('span', {
    staticClass: "upgrading"
  }, [_vm._v("UPGRADING")])] : _vm.gameData.isNextUpgrade ? [_vm._v("Congratulations,"), _c('br'), _vm._v(" the upgrade was successful")] : [_c('span', [_vm._v("UPGRADED")])]], 2), _vm.upgradeResultInfo.show && _vm.gameProgress ? _c('div', {
    staticClass: "pop-quickUpgrade-main"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-bot"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-bot-main"
  }, [_vm.gameData.isQuickUpgradeLoading && _vm.gameData.isContinue ? _c('div', {
    staticClass: "pop-quickUpgrade-tag"
  }, [_c('svg-icon', {
    staticClass: "icon-up",
    attrs: {
      "name": "icon-up"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "pop-quickUpgrade__avatar"
  }, [_c('img', {
    class: [_vm.upgradeResultInfo.anim.step1 && 'step1', _vm.upgradeResultInfo.anim.step2 && 'step2'],
    attrs: {
      "src": require(`@images/avatar/body/${_vm.gameProgress.currentLevel >= _vm.botImgLimit ? _vm.botImgLimit : _vm.gameProgress.currentLevel}.png`),
      "alt": ""
    }
  })])])]), _c('div', {
    staticClass: "pop-quickUpgrade-info"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-btn-detail",
    on: {
      "click": _vm.onQuickUpgradeDetail
    }
  }, [_vm._v("Detail "), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('div', {
    staticClass: "pop-quickUpgrade-levels"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-levels__title"
  }, [_vm._v("l have reached")]), _c('m-level-progress', {
    attrs: {
      "width": _vm.isMobile ? 760 : 950,
      "progress": _vm.gameProgress.progressInfo.completion_rate * 100,
      "level": [_vm.gameProgress.currentLevel, _vm.gameProgress.nextLevel]
    }
  })], 1), _vm.gameData.totalResource.coin || _vm.gameData.totalResource.spins || _vm.gameData.totalResource.ticket || _vm.gameData.totalResource.stock ? _c('div', {
    staticClass: "pop-quickUpgrade-reward"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-reward-main"
  }, [_c('div', {
    staticClass: "pop-quickUpgrade-reward__title"
  }, [_c('span', [_vm._v("Benefits obtained")])]), _c('div', {
    staticClass: "pop-quickUpgrade-reward-list"
  }, [_vm.gameData.totalResource.coin ? _c('div', {
    staticClass: "pop-quickUpgrade-reward-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-hic.png`),
      "alt": ""
    }
  }), _c('span', [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.gameData.totalResource.coin)
    }
  })], 1)]) : _vm._e(), _vm.gameData.totalResource.spins ? _c('div', {
    staticClass: "pop-quickUpgrade-reward-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-spins.png`),
      "alt": ""
    }
  }), _c('span', [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.gameData.totalResource.spins)
    }
  })], 1)]) : _vm._e(), _vm.gameData.totalResource.ticket ? _c('div', {
    staticClass: "pop-quickUpgrade-reward-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon/icon-pass.png`),
      "alt": ""
    }
  }), _c('span', [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.gameData.totalResource.ticket)
    }
  })], 1)]) : _vm._e(), _vm.gameData.totalResource.stock ? _c('div', {
    staticClass: "pop-quickUpgrade-reward-item"
  }, [_c('img', {
    attrs: {
      "src": require(`@images/icon-stock.png`),
      "alt": ""
    }
  }), _c('span', [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.gameData.totalResource.stock)
    }
  })], 1)]) : _vm._e()])])]) : _vm._e(), _vm.gameData?.errorCode > 0 && _vm.gameData?.errorCode == 402 ? _c('div', {
    staticClass: "gifts-btns-main"
  }, [_c('div', {
    staticClass: "gifts-btns__title"
  }, [_c('span', [_vm._v("Get more HlD ")]), _c('i', [_vm._v("Balance: "), _c('img', {
    attrs: {
      "src": require('@images/icon/icon-hic.png'),
      "alt": ""
    }
  }), _c('em', {
    class: _vm.gameData?.errorCode > 0 && _vm.gameData?.errorCode == 402 && 'ins'
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.coin)))])])]), _c('div', {
    staticClass: "gifts-btns-list"
  }, _vm._l(_vm.menuBtns, function (val, key, index) {
    return _c('div', {
      key: index,
      staticClass: "gifts-btns-item",
      class: key,
      on: {
        "click": () => _vm.$router.push(val.page)
      }
    }, [_c('span', [_vm._v(_vm._s(val.title))]), _c('i', {
      domProps: {
        "innerHTML": _vm._s(val.reward)
      }
    })]);
  }), 0)]) : _c('div', {
    staticClass: "gifts-btns__balance"
  }, [_vm._v(" Balance: "), _c('img', {
    attrs: {
      "src": require('@images/icon/icon-hic.png'),
      "alt": ""
    }
  }), _c('em', {
    class: _vm.gameData?.errorCode > 0 && _vm.gameData?.errorCode == 402 && 'ins'
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.userInfo.coin)))])])])]) : _vm._e()]), _c('m-menu'), _c('pop-face-tip'), _c('m-login-rewards')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-particles"
  }, [_c('div', {
    attrs: {
      "id": "particles-js"
    }
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-new"
  }, [_c('em', [_vm._v("NEW")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "index-new"
  }, [_c('em', [_vm._v("NEW")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "loading"
  }, [_c('div', {
    staticClass: "circleLoading"
  })]);
}];
export { render, staticRenderFns };